<template>
  <div
    class="nav"
    :class="{'is_index':$route.name==='index'}"
  >
    <div class="nav-list">
      <div class="logo">
        <router-link
          to="index"
          title="CEASIA"
        ></router-link>
      </div>
      <div
        class="index-ch-en"
        v-show="$route.name!=='Careers '"
      >
        <span
          @click="toggleLang('zh')"
          :disabled="$i18n.locale == 'zh'"
          title="中文"
        >
          中文
        </span>
        <span>/</span>
        <span
          @click="toggleLang('en')"
          :disabled="$i18n.locale == 'en'"
          title="English"
        >
          En
        </span>
      </div>
      <ul>
        <li
          v-for='(val,index) in NavList'
          :key='index'
          @click="url(val.navlink)"
        >
          <a
            v-if="val.navlink==='1' || val.navlink==='2'"
            class="current"
            :title=val.navtitle
          >
            <!-- {{val.navlink}} -->
            {{val.navtitle}}
          </a>
          <router-link
            v-else-if="val.navlink!='1'"
            :to=val.navlink
            class="current"
            :title=val.navtitle
          >
            <!-- {{val.navlink}} -->
            {{val.navtitle}}
          </router-link>
          <!-- <span style="height: 2px; right: 0px; width: 0px; left: 50%;"></span> -->
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Nav',
  data() {
    return {
      a: false,
      // isIndex: false
    }
  },
  methods: {
    url(link) {
      // console.log(link);
      // console.log(window.location);
      if (link === '1') {
        window.open('https://www.sonkwo.hk/', '_blank')
      }
      if (link === '2') {
        window.open('https://www.sonkwo.hk/publishers', '_blank')
      }
    },
    toggleLang(lang) {
      // var strUrl = location.href;
      // var arrUrl = strUrl.split("/");
      // var strPage = arrUrl[arrUrl.length - 1];
      // console.log(strPage);
      // location.reload();
      if (lang === 'zh') {
        localStorage.setItem('locale', 'zh')
        this.$i18n.locale = localStorage.getItem('locale')
        document.title = this.$t('IndexTitle')
      } else if (lang === 'en') {
        localStorage.setItem('locale', 'en')
        this.$i18n.locale = localStorage.getItem('locale')
        document.title = this.$t('IndexTitle')
      }
    },
  },
  computed: {
    NavList() {
      if (this.$t('Nav') !== 'Nav') {
        return this.$t('Nav')
      }
    },
  },
  created() {
    console.log(this.$route.name)
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import './style/nav.css';
/* [disabled='disabled']{
  color: rgba(255,255,255,1);
} */

.is_index ul li a {
  color: #bbb;
}
.is_index ul li a {
  color: #bbb;
}
.is_index .logo a {
  border-bottom: 0;
  padding: 0;
  background-image: url(./images/head-logo.png);
}
.is_index .index-ch-en a {
  border-bottom: none;
}
.is_index .index-ch-en a {
  color: #bbb;
}
.is_index ul li a:hover {
  color: #fff;
}
.is_index {
  background-color: rgba(0, 0, 0, 0.5);
}
.is_index .router-link-active {
  color: #fff !important;
}
.is_index .index-ch-en span[disabled='disabled'] {
  color: #fff;
}
.is_index .router-link-active::after {
  content: '';
  width: 20px;
  height: 2px;
  background: #fff;
  position: absolute;
  left: 0;
  bottom: -10px !important;
  opacity: 1 !important;
}
.is_index ul li a::after {
  background: #fff;
}
.is_index .logo .router-link-active::after {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/nav/Nav.vue